import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "linked-reports-modal",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "linked-reports-modal-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "linked-reports-modal-title"
  }, " Linked Reports "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_5 = { class: "table table-hover mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "25%" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { width: "20%" }, "Ref"),
    /*#__PURE__*/_createElementVNode("th", { width: "30%" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { width: "25%" }, "Download")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf" }, null, -1)

import { computed, inject, ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import ProgressButton from "@/components/ProgressButton.vue";
import { Report, Dictionary } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkedReportsModal',
  setup(__props) {

const store = useStore();
const actProperty: any = inject('actProperty');
const toasted = useToast();

// Accessing Vuex getters
const report = computed(() => store.getters['reports/current'] as Report);
const linkedReports = computed(() => store.getters['reports/linked'] as Report[]);
const dictionary = computed(() => store.getters['dictionary/current'] as Dictionary);

// Methods converted to regular functions
const removeRequest = (id: string) => {
  store.commit('app/removeRequest', id);
};

const generateReportPdfAction = async (report: Report): Promise<any> => {
  return await store.dispatch('reports/generateReportPdf', report);
};

const generateReportPdf = async (report: Report, requestId: string) => {
  generateReportPdfAction(report)
    .then((key: string) => {
      actProperty.downloadAttachment(key);
      toasted.success(`Report ${report.ref} PDF downloaded`);
    })
    .finally(() => removeRequest(requestId))
    .catch((err: any) => actProperty.displayError(err));
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("form", null, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkedReports.value, (linkedReport, $index) => {
                return (_openBlock(), _createElementBlock("tr", { key: $index }, [
                  _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatDateForDisplay(linkedReport.date)), 1),
                  _createElementVNode("td", null, _toDisplayString(linkedReport.ref), 1),
                  _createElementVNode("td", null, _toDisplayString(_unref(actProperty).formatReportType(linkedReport.type, dictionary.value)), 1),
                  _createElementVNode("td", null, [
                    _createVNode(ProgressButton, {
                      onClick: ($event: any) => (generateReportPdf(linkedReport, $event)),
                      onDblclick: ($event: any) => (generateReportPdf(linkedReport, $event)),
                      class: "btn btn-sm btn-outline-primary",
                      title: "Linked Report",
                      "data-dismiss": "modal"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick", "onDblclick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})